import React from 'react';
import PropTypes from 'prop-types';
import ImageCropped from '../../../image_cropped';
import PlanBadge from './PlanBadge';

function AttachableRepresentedEntity({ entity, onClickCallback }) {
  const btnClasses = 'btn btn-outline-primary d-inline-flex flex-row cursor-pointer mb-3 me-2 align-items-center';
  const selfExpertIsCurrentUser = entity.selfExpert && entity.isCurrentUser;

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      onClickCallback(entity);
    }
  };

  return (
    <div
      className={btnClasses}
      id={`${entity.type}_${entity.id}`.toLowerCase()}
      onClick={() => onClickCallback(entity)}
      onKeyDown={handleKeyDown}
      role="button"
      style={{ lineHeight: '1.1em' }}
      tabIndex="0"
    >
      <ImageCropped
        roundedCircle
        wrapperClasses="me-2"
        src={entity.profileImageUrl}
        alt={entity.name}
        size={40}
      />
      <div className="d-flex flex-column align-items-start justify-content-center text-start">
        <div style={{ marginBottom: '1px' }}>
          {selfExpertIsCurrentUser && 'Myself: '}
          <strong>{entity.name}</strong>
        </div>
        {entity.subheading && <div>{entity.subheading}</div>}
      </div>
      <PlanBadge
        isPaid={entity.isPaid}
        isViewersOwnProfile={entity.isCurrentUser}
        firstName={entity.firstName}
        className="ms-3"
      />
    </div>
  );
}

AttachableRepresentedEntity.propTypes = {
  entity: PropTypes.shape({
    profileImageUrl: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    selfExpert: PropTypes.bool,
    selfExpertUserId: PropTypes.string,
    subheading: PropTypes.string,
    isPaid: PropTypes.bool,
    isCurrentUser: PropTypes.bool,
    firstName: PropTypes.string,
  }),
  onClickCallback: PropTypes.func,
};

AttachableRepresentedEntity.defaultProps = {
  entity: undefined,
  onClickCallback: () => {
  },
};

export default AttachableRepresentedEntity;
